import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class CountPointsInPolygons extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.countpointsinpolygons',
            group: 'Spatial Analysis',
            title: 'ST Count Points in Polygons',
            description: `
      This component counts the number of points that intersect with each polygon on the input table.
      `,
            starred: true
        }, [
            {
                name: 'points',
                type: WorkflowComponentParamType.InputTable,
                title: 'Points table'
            },
            {
                name: 'polygons',
                type: WorkflowComponentParamType.InputTable,
                title: 'Polygons table'
            },
            {
                name: 'geopoints',
                type: WorkflowComponentParamType.Column,
                title: 'Geo column in points table',
                parent: 'points',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'geopolygons',
                type: WorkflowComponentParamType.Column,
                title: 'Geo column in polygons table',
                parent: 'polygons',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'idcol',
                type: WorkflowComponentParamType.Column,
                title: 'Column with identifier in polygons table',
                parent: 'polygons',
                dataType: [ColumnDataType.String, ColumnDataType.Number]
            }
        ]);
        this.supportedProviders = [
            Provider.BigQuery,
            Provider.Snowflake,
            Provider.Postgres,
            Provider.Redshift
        ];
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.BigQuery:
            case Provider.Snowflake:
            case Provider.Postgres:
                return dedent `SELECT
                  polygonsb.*,
                  COALESCE(__count.count, 0) AS count
                FROM ${connection.quoteName(params.polygons)} polygonsb
                LEFT JOIN
                  (
                    SELECT
                      polygons.${params.idcol} poligonid,
                      count(*) count
                    FROM
                      ${connection.quoteName(params.polygons)} as polygons,
                      ${connection.quoteName(params.points)} as points
                    WHERE
                        ST_INTERSECTS(
                          ${connection.processInputGeogColumn(`polygons.${params.geopolygons}`)},
                          ${connection.processInputGeogColumn(`points.${params.geopoints}`)}
                        )
                    GROUP BY
                        polygons.${params.idcol}
                  ) __count
                ON __count.poligonid = polygonsb.${params.idcol}`;
            case Provider.Redshift:
                return dedent `SELECT
                  polygonsb.*,
                  COALESCE(__count.count, 0) AS count
                FROM ${connection.quoteName(params.polygons)} polygonsb
                LEFT JOIN
                  (
                    SELECT
                      polygons.${params.idcol} poligonid,
                      count(*) count
                    FROM
                      ${connection.quoteName(params.polygons)} as polygons,
                      ${connection.quoteName(params.points)} as points
                    WHERE
                        ST_INTERSECTS(
                          polygons.${params.geopolygons},
                          points.${params.geopoints}
                        )
                    GROUP BY
                        polygons.${params.idcol}
                  ) __count
                ON __count.poligonid = polygonsb.${params.idcol}`;
            default:
                return null;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns }) {
        return addColumn(columns.points, {
            name: 'count',
            type: ColumnDataType.Number
        });
    }
}
export { CountPointsInPolygons };
